import { QueryCache } from "@tanstack/react-query";
import { ORDER_DETAILS } from "../../../../constants/routes";
import { getNextOrderIdInList } from "./getNextOrderIdInList";

export const getOrderAcceptRedirectUrl = ({
  orderId,
  uid,
  businessId,
  queryCache,
}: {
  orderId: number;
  uid: string | undefined;
  businessId: number | undefined;
  queryCache: QueryCache;
}) => {
  const nextOrPreviousOrderId = getNextOrderIdInList({
    queryCache,
    orderId,
    uid,
    businessId,
  });
  return nextOrPreviousOrderId
    ? `${ORDER_DETAILS.href({ orderId: nextOrPreviousOrderId })}?tab=Order+requests`
    : `${ORDER_DETAILS.href({ orderId })}?tab=All+orders`;
};
